import { useAuth0 } from '@auth0/auth0-react'
import * as Sentry from '@sentry/react'
import React from 'react'
import '../styles/portal/layout/layout.css'

interface LayoutProps {
  children: React.ReactNode
  allowScrolling?: boolean // For report pages that need natural scrolling
}

const Layout: React.FC<LayoutProps> = ({ children, allowScrolling = false }) => {
  const { isAuthenticated, logout } = useAuth0()

  const handleSignOut = async () => {
    return Sentry.startSpan(
      {
        op: 'ui.click',
        name: 'User Logout',
      },
      async (span) => {
        span.setAttribute('auth.provider', 'auth0')
        try {
          // Clear Sentry user context on logout
          Sentry.setUser(null)
          await logout({ logoutParams: { returnTo: window.location.origin } })
        } catch (error) {
          span.setAttribute('error', true)
          if (error instanceof Error) {
            span.setAttribute('error.message', error.message)
          }
          Sentry.captureException(error, { tags: { operation: 'auth.logout' } })
          throw error
        }
      }
    )
  }

  return (
    <div className="absolute inset-0 flex h-screen w-screen flex-col bg-gray-50">
      {isAuthenticated && (
        <header className="header">
          <div className="flex items-center justify-between px-6 py-4">
            <div className="flex items-center gap-4">
              <img src="/icons/Inflection_Icon_Dark.svg" alt="Inflection Medicine" className="icon" />
              <span className="text-xl text-white">Inflection Medicine</span>
            </div>
            <button
              onClick={handleSignOut}
              className="flex items-center gap-2 text-white transition-colors duration-200 hover:text-gray-200"
              title="Sign Out"
            >
              <img src="/icons/signout.svg" alt="Sign Out" />
            </button>
          </div>
        </header>
      )}

      {/* Main Content */}
      <main className={`w-full flex-1 ${allowScrolling ? 'overflow-auto' : 'overflow-hidden'}`}>{children}</main>
    </div>
  )
}

export default Layout
